import { RoomTypeContainer } from '../../containers/advancedFilters/RoomTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const roomType: IFilter = {
  component: RoomTypeContainer,
};
